// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face{font-family:VideoJS;src:url(/assets/fonts/videojs/VideoJS.woff) format(\"woff\");font-weight:400;font-style:normal}", ""]);
// Exports
module.exports = exports;
